// Duits (de-DE), food: zelfde vorm als food.nl.ts. Wat ontbreekt valt terug op het Nederlands
// (nooit een rauwe sleutel op het scherm).
export const foodDe = {
    nav: 'Essen',
    title: 'Essen',
    tabs: {
        shopping: 'Einkaufen',
        recipes: 'Rezepte',
        menu: 'Wochenplan',
        pantry: 'Vorrat',
    },
    undo: 'Rückgängig',
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    remove: 'Löschen',
    retry: 'Erneut versuchen',
    errorLoad: 'Das Laden hat nicht geklappt. Versuch es noch einmal.',
    errorSave: 'Das Speichern hat nicht geklappt. Versuch es noch einmal.',
    categories: {
        produce: 'Obst und Gemüse',
        bakery: 'Brot und Frühstück',
        dairy: 'Milchprodukte und Eier',
        meat: 'Fleisch und Fisch',
        pantry: 'Vorratsschrank',
        drinks: 'Getränke',
        household: 'Haushalt',
        other: 'Sonstiges',
    },
    units: {
        g: 'Gramm',
        kg: 'Kilo',
        ml: 'ml',
        cl: 'cl',
        dl: 'dl',
        l: 'Liter',
        el: 'Esslöffel',
        tl: 'Teelöffel',
        kop: 'Tasse',
        snuf: 'Prise',
        stuk: 'Stück',
        teen: 'Zehe',
        blik: 'Dose',
        pak: 'Packung',
        zak: 'Beutel',
        bos: 'Bund',
        plak: 'Scheibe',
        fles: 'Flasche',
        doos: 'Schachtel',
        krop: 'Kopf',
        pot: 'Glas',
        takje: 'Zweig',
        handje: 'Handvoll',
        scheut: 'Schuss',
    },
    shopping: {
        addLabel: 'Was fehlt noch?',
        addPlaceholder: 'Zum Beispiel 2 Packungen Milch',
        add: 'Hinzufügen',
        frequent: 'Oft gekauft',
        inBasket: 'Im Korb ({count})',
        clearChecked: 'Abgehakte löschen',
        newList: 'Liste',
        newListTitle: 'Neue Liste',
        listName: 'Name der Liste',
        listNameHint: 'Zum Beispiel Markt oder Drogerie',
        listsLabel: 'Einkaufslisten',
        renameList: 'Liste bearbeiten',
        archiveList: 'Liste löschen',
        listMenu: 'Mehr zu dieser Liste',
        archiveAsk: 'Liste {name} löschen?',
        archiveHint: 'Was darauf steht, wird mitgelöscht. Du kannst es sofort rückgängig machen.',
        archivedList: 'Liste {name} gelöscht',
        lastList: 'Die letzte Liste kann nicht weg. Gib ihr lieber einen anderen Namen.',
        emptyTitle: 'Alles im Haus',
        emptyBody: 'Schreib hier auf, was fehlt; alle sehen es sofort.',
        added: '{name} steht drauf',
        merged: '{name}: jetzt {amount}',
        removed: '{name} gelöscht',
        cleared: 'Abgehakte Einkäufe gelöscht',
        viaTablet: 'über das Tablet',
        forRecipe: 'für {title}',
        editItem: 'Einkauf bearbeiten',
        name: 'Name',
        amount: 'Menge',
        unit: 'Einheit',
        noUnit: 'Keine',
        note: 'Notiz',
        icon: 'Symbol',
        list: 'Liste',
        check: '{name} abhaken',
        uncheck: '{name} zurücksetzen',
        addedBy: 'Hinzugefügt von {name}',
    },
    recipes: {
        search: 'Rezept suchen',
        filterAll: 'Alle',
        filterOwn: 'Eigene',
        filterLibrary: 'Sammlung',
        add: 'Rezept',
        newTitle: 'Neues Rezept',
        editTitle: 'Rezept bearbeiten',
        modeManual: 'Selbst ausfüllen',
        modeLink: 'Von einem Link',
        link: 'Link zum Rezept',
        linkHint: 'Funktioniert mit Rezeptseiten und mit YouTube, TikTok und Instagram.',
        fetch: 'Abrufen',
        fetching: 'Rezept wird abgerufen…',
        name: 'Name des Rezepts',
        description: 'Kurze Beschreibung',
        servings: 'Personen',
        minutes: 'Minuten',
        ingredients: 'Zutaten',
        ingredientsHint: 'Eine pro Zeile, zum Beispiel 500 g Hackfleisch',
        steps: 'Zubereitung',
        stepsHint: 'Ein Schritt pro Zeile',
        minutesShort: '{n} Min.',
        people: '{n} Pers.',
        video: 'Video',
        needsIngredients: 'Füge die Zutaten hinzu',
        noResults: 'Kein Rezept gefunden',
        noResultsBody: 'Versuch ein anderes Wort oder füge selbst eins hinzu.',
        emptyTitle: 'Noch keine Rezepte',
        emptyBody: 'Füge dein erstes Rezept hinzu oder hol dir eins über einen Link.',
        toMenu: 'In den Wochenplan',
        toList: 'Auf die Liste',
        edit: 'Bearbeiten',
        photo: 'Foto hinzufügen',
        changePhoto: 'Anderes Foto',
        removePhoto: 'Foto entfernen',
        photoUploading: 'Foto wird hochgeladen…',
        photoTooLarge: 'Dieses Foto ist zu groß.',
        photoUnsupported: 'Diese Datei ist kein Foto, das wir verwenden können.',
        archive: 'Ausblenden',
        archived: '{title} ausgeblendet',
        openVideo: 'Video ansehen',
        openSource: 'Zur Website',
        back: 'Alle Rezepte',
        fromLibrary: 'Aus der Sammlung',
        ingredientsEmpty: 'Noch keine Zutaten.',
        stepsEmpty: 'Noch keine Zubereitung.',
        toListTitle: 'Auf die Einkaufsliste',
        toListBody: 'Was schon im Vorrat ist oder immer im Haus ist, ist abgewählt.',
        toListDo: 'Auf die Liste setzen',
        toListDone: '{count} auf {list}',
        toListMerged: '{count} auf {list}, {merged} zusammengefasst',
        toListNothing: 'Alles steht schon auf der Liste oder ist im Haus.',
        staple: 'immer im Haus',
        inPantry: 'im Haus',
        pickDayTitle: 'In den Wochenplan',
        pickDay: 'Wähle einen Tag',
        planned: '{title} steht am {day} auf dem Plan',
        created: '{title} hinzugefügt',
        imported: '{title} abgerufen',
        importErrors: {
            no_recipe_found: 'Auf dieser Seite gibt es kein Rezept, das wir lesen können. Selbst ausfüllen?',
            blocked_address: 'Diesen Link können wir nicht öffnen.',
            invalid_url: 'Nutze einen sicheren Link (der mit https beginnt).',
            too_large: 'Diese Seite ist zu groß zum Lesen.',
            timeout: 'Die Website hat nicht rechtzeitig geantwortet. Versuch es später noch einmal.',
            fetch_failed: 'Die Website ist gerade nicht erreichbar.',
        },
        fillManually: 'Selbst ausfüllen',
    },
    menu: {
        week: 'Woche {week}',
        range: '{from} – {to}',
        thisWeek: 'Diese Woche',
        prev: 'Letzte Woche',
        next: 'Nächste Woche',
        allToList: 'Alles auf die Liste',
        choose: 'Wählen',
        chooseFor: 'Wähle, was wir am {day} essen',
        dragHint: 'Zieh ein Rezept auf einen Tag',
        tapHint: 'Tippe bei einem Tag auf + Wählen',
        moreRecipes: 'Mehr Rezepte ({count})',
        freeSection: 'Oder etwas anderes, zum Beispiel Essen gehen',
        freeSave: 'In den Plan',
        pickRecipe: 'Wähle ein Rezept',
        shelf: 'Rezepte',
        removeMeal: '{title} aus dem Plan nehmen',
        removed: '{title} aus dem Plan genommen',
        moved: 'Verschoben auf {day}',
        freeText: 'Oder tippe etwas anderes',
        freePlaceholder: 'Zum Beispiel Essen gehen',
        emptyTitle: 'Noch nichts im Wochenplan',
        emptyBody: 'Zieh ein Rezept auf einen Tag.',
        today: 'heute',
        nothingToList: 'Diese Woche stehen noch keine Rezepte im Plan.',
        servings: '{n} Pers.',
    },
    pantry: {
        addLabel: 'Was haben wir im Haus?',
        addPlaceholder: 'Zum Beispiel 1 kg Kartoffeln',
        add: 'Hinzufügen',
        listLabel: 'Im Vorrat',
        removeItem: '{name} aus dem Vorrat nehmen',
        removed: '{name} aus dem Vorrat',
        suggestionsTitle: 'Was können wir kochen?',
        allInHouse: 'Alles im Haus',
        stillNeeded: 'Noch nötig: {items}',
        emptyTitle: 'Noch nichts im Vorrat',
        emptyBody: 'Trag ein, was du hast; wir überlegen, was du kochen kannst.',
        noSuggestions: 'Noch kein Rezept, für das genug im Haus ist.',
        staples: 'Salz, Pfeffer, Öl und Wasser zählen als immer im Haus.',
    },
    kiosk: {
        entry: 'Essen',
        back: 'Zurück',
        tonight: 'Heute Abend essen wir',
        nothingPlanned: 'Noch nichts geplant',
        nothingPlannedBody: 'Mama oder Papa wählt in der App.',
        tomorrow: 'Morgen',
        add: 'Dazu',
        addTitle: 'Was fehlt noch?',
        close: 'Schließen',
        added: '{name} steht drauf',
        oops: 'Hoppla',
        emptyTitle: 'Alles im Haus',
        check: '{name}: im Korb?',
        // UX-ronde bord: een regel in het mandje met één tik terugzetten.
        backOnList: '{name}: zurück auf die Liste',
        confirm: 'Im Korb',
        shopping: 'Einkaufen',
        week: 'Diese Woche',
        inBasket: '{name} im Korb',
        more: 'Mehr Einkäufe',
        alreadyOn: '{name} stand schon drauf',
        typeOwn: 'Selbst tippen',
        typeLabel: 'Was fehlt noch?',
        typePlaceholder: 'Z. B. Müsli',
        typeAdd: 'Dazu',
        closeTyping: 'Zurück zu den Bildern',
        moreTiles: 'Mehr Bilder',
    },
};
//# sourceMappingURL=food.de.js.map